import { Box, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material'
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid'
import { useState, useEffect } from 'react'
import { Button } from 'src/components/forms'
import { useConfirmationDialog } from 'src/hooks/useConfirmationDialog'
import { HttpGroup } from 'src/http/group/httpGroup'
import { GroupSectorComercialViewDTO, GroupSectorComercialViewDTOFields } from 'src/types/group/groupData'

export default function EditSectorComercialesGrupo({ onClose, grupo }: { onClose: () => void; grupo: number }) {
    const [sectores, setSectores] = useState<GroupSectorComercialViewDTO[]>()

    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>()

    const columnas: GridColDef<GroupSectorComercialViewDTO>[] = [
        {
            headerName: 'Sector comercial',
            field: GroupSectorComercialViewDTOFields.NombreSectorComercial,
            flex: 3
        }
    ]

    useEffect(() => {
        HttpGroup.getSectoresComercialPorGrupo(grupo).then(sectores => {
            setSectores(sectores)
            const selected = sectores
                .filter(sector => sector[GroupSectorComercialViewDTOFields.PerteneceASector])
                .map(sector => sector[GroupSectorComercialViewDTOFields.CodSectorComercial])
            setRowSelectionModel(prev => [...new Set([...selected, ...(prev || [])])])
        })
    }, [])

    const { askConfirmation } = useConfirmationDialog()

    const onCancelHandler = () => {
        askConfirmation(onClose, '¿Seguro que desea salir? Los cambios no se guardarán.')
    }

    const onSubmitWrapper = () => {
        return new Promise<void>((resolve, reject) => {
            HttpGroup.updateSectoresComercialPorGrupo(grupo, [...((rowSelectionModel as number[]) || [])]).then(() => {
                setTimeout(onClose, 500)
                resolve()
            })
        })
    }

    return (
        <>
            <DialogTitle>{'Sectores Comerciales de Grupo'}</DialogTitle>
            <Stack spacing={2}>
                <DialogContent>
                    <DialogContentText>{`Seleccione los sectores comerciales asociados.`}</DialogContentText>
                </DialogContent>
                <Box
                    sx={{
                        height: '100%'
                    }}
                >
                    <DataGrid
                        hideFooterPagination
                        columns={columnas}
                        checkboxSelection
                        rowSelectionModel={rowSelectionModel}
                        onRowSelectionModelChange={setRowSelectionModel}
                        rows={sectores ? sectores : []}
                        getRowId={row => row[GroupSectorComercialViewDTOFields.CodSectorComercial]}
                        density='compact'
                    />
                </Box>
            </Stack>
            <DialogActions>
                <Button variant='text' color='primary' onClick={onCancelHandler}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' promise={onSubmitWrapper}>
                    Guardar
                </Button>
            </DialogActions>
        </>
    )
}
